/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dialog_Connection_Issue_TitleInputs */

const en_dialog_connection_issue_title = /** @type {(inputs: Dialog_Connection_Issue_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Connection Issue`)
};

const ar_dialog_connection_issue_title = /** @type {(inputs: Dialog_Connection_Issue_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`مشكلة في الاتصال`)
};

const de_dialog_connection_issue_title = /** @type {(inputs: Dialog_Connection_Issue_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verbindungsproblem`)
};

const es_dialog_connection_issue_title = /** @type {(inputs: Dialog_Connection_Issue_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Problema de conexión`)
};

const fr_dialog_connection_issue_title = /** @type {(inputs: Dialog_Connection_Issue_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Problème de connexion`)
};

const it_dialog_connection_issue_title = /** @type {(inputs: Dialog_Connection_Issue_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Problema di connessione`)
};

const ja_dialog_connection_issue_title = /** @type {(inputs: Dialog_Connection_Issue_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`接続エラーが発生しました`)
};

const ko_dialog_connection_issue_title = /** @type {(inputs: Dialog_Connection_Issue_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`연결 이슈`)
};

const pt_br_dialog_connection_issue_title = /** @type {(inputs: Dialog_Connection_Issue_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Problema de conexão`)
};

const ru_dialog_connection_issue_title = /** @type {(inputs: Dialog_Connection_Issue_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Проблема с подключением`)
};

const th_dialog_connection_issue_title = /** @type {(inputs: Dialog_Connection_Issue_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ปัญหาการเชื่อมต่อ`)
};

const tr_dialog_connection_issue_title = /** @type {(inputs: Dialog_Connection_Issue_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bağlantı Sorunu`)
};

const zh_cn_dialog_connection_issue_title = /** @type {(inputs: Dialog_Connection_Issue_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`连接失败`)
};

const zh_tw_dialog_connection_issue_title = /** @type {(inputs: Dialog_Connection_Issue_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`連線失敗`)
};

/**
* | output |
* | --- |
* | "Connection Issue" |
*
* @param {Dialog_Connection_Issue_TitleInputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const dialog_connection_issue_title = /** @type {((inputs?: Dialog_Connection_Issue_TitleInputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dialog_Connection_Issue_TitleInputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_dialog_connection_issue_title(inputs)
	if (locale === "ar") return ar_dialog_connection_issue_title(inputs)
	if (locale === "de") return de_dialog_connection_issue_title(inputs)
	if (locale === "es") return es_dialog_connection_issue_title(inputs)
	if (locale === "fr") return fr_dialog_connection_issue_title(inputs)
	if (locale === "it") return it_dialog_connection_issue_title(inputs)
	if (locale === "ja") return ja_dialog_connection_issue_title(inputs)
	if (locale === "ko") return ko_dialog_connection_issue_title(inputs)
	if (locale === "pt_br") return pt_br_dialog_connection_issue_title(inputs)
	if (locale === "ru") return ru_dialog_connection_issue_title(inputs)
	if (locale === "th") return th_dialog_connection_issue_title(inputs)
	if (locale === "tr") return tr_dialog_connection_issue_title(inputs)
	if (locale === "zh_cn") return zh_cn_dialog_connection_issue_title(inputs)
	return zh_tw_dialog_connection_issue_title(inputs)
});